export const PERMISSION_LABEL = {
    granted: 'concedido',
    denied: 'denegado',
    prompt: 'sin decidir',
    unsupported: 'no soportado',
};

export const BIOMETRY_LABEL = {
    face: 'Reconocimiento facial',
    fingerprint: 'Huella',
    iris: 'Iris',
    device: 'Credencial del dispositivo',
    none: 'Sin biometría',
};

export function describeHost(host, platform) {
    if (host === 'capacitor') {
        if (platform === 'ios') return 'App nativa iOS (Capacitor)';
        if (platform === 'android') return 'App nativa Android (Capacitor)';
        return 'App nativa (Capacitor)';
    }
    if (host === 'webkit') return 'App nativa iOS';
    if (host === 'iframe') return 'Embebido en una página anfitriona';
    return 'Navegador web';
}
